/**
 * Default reponova.yml written into the editor directory on first install.
 */
export const DEFAULT_CONFIG_YAML = `# reponova.yml — All paths relative to this file's location.

output: ../reponova-out

repos:
  - name: my-project
    path: ..

# ── Providers (optional — AI backends for embeddings, summaries, descriptions) ──
# Define named providers here, then reference them from features below.
# Default (no provider) = algorithmic mode (TF-IDF embeddings, rule-based summaries).
# providers:
#   my-openai:
#     type: openai
#     base_url: https://api.openai.com/v1
#     model: text-embedding-3-small
#     api_key: \${OPENAI_API_KEY}
#   local-llm:
#     type: llama-cpp
#     model: "hf:Qwen/Qwen2.5-0.5B-Instruct-GGUF:Q4_K_M"
#   ollama:
#     type: openai
#     base_url: http://localhost:11434/v1
#     model: nomic-embed-text

# ── Source Code File Filters (shared by graph + outlines) ──
# patterns: []                    # source files (empty = auto-detect by extension)
# exclude: []                     # e.g. ["**/generated/**", "**/*.test.ts"]
# exclude_common: true            # skip node_modules, __pycache__, .git, venv, dist, build, ...
# incremental: true

# ── Documentation ──
docs:
  enabled: true
  # patterns: []                  # empty = auto-detect (.md, .txt, .rst)
  # exclude: []                   # e.g. ["**/CHANGELOG.md"]
  # max_file_size_kb: 500

# ── Language Plugins ──
# Declare plugins here. Installed via \`reponova lang add <package>\`.
# If \`package\` is omitted, resolved as @reponova/lang-<key>.
# plugins:
#   python:
#     enabled: true
#   rust:
#     package: "@exampleorg/lang-rust"
#     enabled: true

# ── Embeddings ──
# Default: TF-IDF (fast, no download). Set provider for ONNX or remote embeddings.
embeddings:
  enabled: true
  # provider: my-openai           # reference a provider defined above

# ── Enrich ──
enrich:
  enabled: true
  # threshold: 0.8                # top 20% of nodes by degree
  # max_communities: 0            # 0 = no limit; N = only top N largest communities
  # candidate_threshold: 0.3      # boundary ratio for candidate classification
  # description_batch_tokens: 40000
  # routing_batch_size: 30
  # concurrency: 4                # max parallel LLM calls
  # max_retry_depth: 3
  # provider: local-llm           # uncomment for LLM-enhanced enrichments
  # max_tokens:                   # per-step LLM output token limits
  #   descriptions: 32768
  #   profiles: 2048
  #   routing: 8192
  #   restructure: 4096
  # profile:                      # community profile prompt limits
  #   max_nodes: 80
  #   max_edges: 50
  # restructure_max_pairs: 20     # max cross-community pairs for merge/split analysis

# ── HTML ──
# html: true
# html_min_degree: 3              # min degree for HTML visualization (unset = all nodes)

# ── Outlines ──
outlines:
  enabled: true
`;
